/**
 * Calculate processing fee using the reverse-charge formula.
 * This ensures that after the payment processor takes its cut from the total
 * charge (amount + fee), the venue nets exactly the original booking amount.
 *
 * Formula: totalToCharge = (amount + fixedFee) / (1 - percentage/100)
 *          processingFee = ceil(totalToCharge) - amount
 *
 * @param {number} amount - The payment amount in cents
 * @param {Object} paymentMethod - Payment method with percentage and usd fee configuration
 * @param {number} paymentMethod.percentage - Percentage fee (0-100)
 * @param {number} paymentMethod.usd - Fixed USD fee
 * @returns {number} The calculated processing fee in cents (integer)
 */
export function calculateProcessingFee(amount, paymentMethod) {
    if (!amount || amount === 0) return 0;
    if (!paymentMethod) return 0;

    const percentageRate =
        paymentMethod.percentage && paymentMethod.percentage > 0
            ? paymentMethod.percentage / 100
            : 0;
    const fixedFeeCents =
        paymentMethod.usd && paymentMethod.usd > 0 ? Math.round(paymentMethod.usd * 100) : 0;

    if (percentageRate === 0 && fixedFeeCents === 0) {
        return 0;
    }

    if (percentageRate === 0) {
        return fixedFeeCents;
    }

    // Reverse-charge: solve for total where total - (total * rate + fixed) = amount
    const totalToCharge = Math.ceil((amount + fixedFeeCents) / (1 - percentageRate));
    return totalToCharge - amount;
}
